import { asMaybeasy, Maybe } from '@execonline-inc/structured-maybe';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLinkBy } from '../../../../../../Links';
import { T } from '../../../../../../Translations';
import CopyToClipboard from '../../../../../CopyToClipboard';
import { ShareUrlResource } from '../../../../Types';

export interface Props {
  shareUrlResource: Maybe<ShareUrlResource>;
}

const ShareUrl: React.FC<Props> = ({ shareUrlResource }) => {
  return asMaybeasy(shareUrlResource)
    .andThen((shareUrlResource) =>
      findLinkBy({ rel: 'shared-url-short-link', type: 'text/html' }, shareUrlResource.links),
    )
    .map((link) => (
      <div className="mt-8 flex max-w-full">
        <div
          className={clsx(
            'rounded-l-lg border border-solid border-gray-300',
            'max-w-[95%] overflow-auto p-4 text-gray-700 lg:w-[480px]',
          )}
        >
          <p>{link.href}</p>
        </div>
        <div
          className={clsx(
            'rounded-r-lg border border-solid',
            'border-teal-600 px-4 py-4 text-teal-600',
          )}
          data-clipboard-text={link.href}
        >
          <CopyToClipboard copyText={link.href} />
        </div>
      </div>
    ))
    .getOrElse(() => (
      <p className="mt-8 text-gray-600">
        <T kind="Your organization has no email domains..." />
      </p>
    ));
};

export default observer(ShareUrl);
